import polyfill from '@babel/polyfill';
import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import SvgSprite from 'vue-svg-sprite';
import Vuetify from 'vuetify';
import VueYouTubeEmbed from 'vue-youtube-embed';
import VueTheMask from 'vue-the-mask';
import orderby from 'lodash.orderby';
import chunk from 'lodash.chunk';
import svgxuse from 'svgxuse';
import {sync} from 'vuex-router-sync';
import dayjs from 'dayjs';
import '@mdi/font/css/materialdesignicons.min.css';
import 'material-design-icons-iconfont';
import IconsPlugin from './plugins/icons';

const savedLang = localStorage.getItem('lang') || 'ru';
document.documentElement.lang = savedLang;

Vue.use(polyfill);

Vue.use(
    SvgSprite, {
      url: '',
    }
);

let url = process.env.VUE_APP_BASE_URL;

Vue.filter('day', (date) => new dayjs(date).format('DD.MM.YYYY'));
Vue.filter('time', (date) => new dayjs(date).format('HH.mm'));
Vue.filter('avatar', (image) => String(image).includes('data:image') ? image : (image) ? url + image : '/icons/user.svg');

Vue.use(Vuetify, {
  iconfont: 'md',
});
Vue.use(VueYouTubeEmbed);
Vue.use(VueTheMask);
Vue.use(orderby);
Vue.use(chunk);
Vue.use(svgxuse);
Vue.use(IconsPlugin);

Vue.config.productionTip = false;

sync(store, router);


new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');


// polyfills
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function(callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}
